import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-solicitud-credito',
  templateUrl: './solicitud-credito.component.html',
  styleUrls: ['./solicitud-credito.component.css']
})
export class SolicitudCreditoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
